import {Routes} from '@angular/router';
import {SearchView} from './search/search.view';
import {DeviceView} from './device/device.view';

export const routes: Routes = [
    {path: 'search', component: SearchView},
    {path: 'device/:id', component: DeviceView},
    {path: '**', redirectTo: 'search'}
];
